/**
 * Permission code aliases for renamed modules. Mirror of
 * backend/src/core/utils/permission-aliases.util.ts — keep the pairs identical.
 * Sales → Growth & Revenue: `growth.*` is canonical, `sales.*` is the kept alias.
 */
export const PERMISSION_PREFIX_ALIASES: ReadonlyArray<readonly [canonical: string, legacy: string]> = [
  ['growth.', 'sales.'],
];

/** Every alias of a permission code, including the code itself. */
export function permissionAliasesOf(code: string): string[] {
  for (const [canonical, legacy] of PERMISSION_PREFIX_ALIASES) {
    if (code.startsWith(canonical)) return [code, legacy + code.slice(canonical.length)];
    if (code.startsWith(legacy)) return [canonical + code.slice(legacy.length), code];
  }
  return [code];
}

/** Adds the paired alias of every code (both directions); keeps order, no duplicates. */
export function expandPermissionAliases(codes: readonly string[]): string[] {
  const out = new Set<string>();
  for (const code of codes) {
    for (const alias of permissionAliasesOf(code)) out.add(alias);
  }
  return [...out];
}

/** Returns the user with alias-expanded permissions (null/undefined pass through). */
export function withPermissionAliases<T extends { permissions?: string[] | null }>(user: T): T;
export function withPermissionAliases<T extends { permissions?: string[] | null }>(user: T | null): T | null;
export function withPermissionAliases<T extends { permissions?: string[] | null }>(user: T | null): T | null {
  if (!user || !Array.isArray(user.permissions)) return user;
  return { ...user, permissions: expandPermissionAliases(user.permissions) };
}
